"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _filterContext = _interopRequireDefault(require("@micado-digital/react-filter/context/filterContext"));
var _Select = _interopRequireDefault(require("@micado-digital/react-filter/FilterItem/Select"));
var _Slider = _interopRequireDefault(require("@micado-digital/react-filter/FilterItem/Slider"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../../locals/it.json"));
var _FilterItem = _interopRequireDefault(require("../FilterItem"));
var _FilterConnector = _interopRequireDefault(require("./FilterConnector.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DrawerToolbar = (0, _component.default)(() => import("../../../../components/DrawerToolbar"));
const FilterConnector = _ref => {
  var _priceFilter$range, _priceFilter$range2, _priceFilter$range3, _priceFilter$range4;
  let {
    lang,
    maxVisibleOptions,
    setFilterOpen,
    showFilter,
    onSubmit
  } = _ref;
  const {
    defaultFilter,
    localValues,
    preSelectedValues,
    selectedFilter,
    setLocalValues,
    onChange
  } = (0, _react.useContext)(_filterContext.default);
  const {
    groups,
    page,
    pageSize,
    price,
    sort
  } = localValues;
  const {
    _loading = false,
    price: priceFilter,
    sort: sortFilter
  } = defaultFilter || {};
  const theme = (0, _useTheme.default)();
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  const css = (0, _FilterConnector.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const getFilterOptions = (0, _react.useCallback)(identifier => {
    var _defaultFilter$identi, _defaultFilter$identi2;
    return (_defaultFilter$identi = defaultFilter === null || defaultFilter === void 0 || (_defaultFilter$identi2 = defaultFilter[identifier]) === null || _defaultFilter$identi2 === void 0 ? void 0 : _defaultFilter$identi2.items) !== null && _defaultFilter$identi !== void 0 ? _defaultFilter$identi : [];
  }, [defaultFilter]);
  const hiddenFilters = (0, _react.useMemo)(() => {
    const _filters = [];
    Object.keys(preSelectedValues).forEach(key => {
      if ((selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.indexOf(key)) === -1) {
        const value = preSelectedValues === null || preSelectedValues === void 0 ? void 0 : preSelectedValues[key];
        _filters.push({
          identifier: key,
          value: (0, _isArray.default)(value) ? value.join(",") : value
        });
      }
    });
    return _filters;
  }, [preSelectedValues, selectedFilter]);
  const handleSort = value => {
    const _localValues = JSON.parse(JSON.stringify(localValues));
    _localValues.sort = value;
    setLocalValues(_localValues);
  };
  const sortOptions = (0, _react.useMemo)(() => {
    const {
      options
    } = sortFilter || {};
    let _options = [];
    options === null || options === void 0 || options.forEach((option, index) => {
      const id = groups && index === 7 ? 8 : index;
      const valueString = option.toLowerCase();
      let selected = index === sort;
      if (index === 7 && sort === 8) {
        selected = true;
      }
      if (index !== 8) {
        _options.push({
          id: id,
          selected: selected,
          title: l("reactShop.productOverview.sort.labels.".concat(valueString)),
          value: id
        });
      }
    });
    return _options;
  }, [groups, l, sort, sortFilter]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.filter, "mco-filter")
  }, isMobile && /*#__PURE__*/_react.default.createElement(DrawerToolbar, {
    setOpen: setFilterOpen,
    title: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.productOverview.titles.filter",
      l: l
    })
  }), lang && /*#__PURE__*/_react.default.createElement("input", {
    name: "lang",
    type: "hidden",
    value: lang
  }), !!groups && /*#__PURE__*/_react.default.createElement("input", {
    name: "groups",
    type: "hidden",
    value: groups
  }), page && /*#__PURE__*/_react.default.createElement("input", {
    name: "page",
    type: "hidden",
    value: page
  }), pageSize && /*#__PURE__*/_react.default.createElement("input", {
    name: "pageSize",
    type: "hidden",
    value: pageSize
  }), hiddenFilters === null || hiddenFilters === void 0 ? void 0 : hiddenFilters.map(_ref2 => {
    let {
      identifier,
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("input", {
      key: identifier,
      name: identifier,
      type: "hidden",
      value: value
    });
  }), isMobile && /*#__PURE__*/_react.default.createElement(_FilterItem.default, {
    accordionVisibleOptions: 1000,
    identifier: "sort",
    key: "sort",
    label: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.productOverview.filter.labels.sort",
      l: l
    }),
    lang: lang,
    loading: _loading,
    maxVisibleOptions: 1000,
    multiple: false,
    options: sortOptions,
    showAccordion: true,
    showCount: false,
    showSelectedValues: true,
    sort: false,
    value: localValues === null || localValues === void 0 ? void 0 : localValues.sort,
    CheckboxProps: {
      size: "small",
      variant: "outlined"
    },
    onChange: (identifier, value) => handleSort(value),
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    showAll: false
  })), showFilter && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.map(identifier => {
    var _defaultFilter$identi3;
    const options = getFilterOptions(identifier);
    if ((0, _isEmpty.default)(options)) return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: identifier
    });
    return /*#__PURE__*/_react.default.createElement(_FilterItem.default, {
      accordionVisibleOptions: maxVisibleOptions,
      identifier: identifier,
      key: identifier,
      label: defaultFilter === null || defaultFilter === void 0 || (_defaultFilter$identi3 = defaultFilter[identifier]) === null || _defaultFilter$identi3 === void 0 ? void 0 : _defaultFilter$identi3.title,
      lang: lang,
      loading: _loading,
      maxVisibleOptions: maxVisibleOptions,
      options: options,
      showAccordion: isMobile,
      showAllOptions: true,
      showSelectedValues: true,
      value: localValues === null || localValues === void 0 ? void 0 : localValues[identifier],
      CheckboxProps: {
        size: "small",
        variant: "outlined"
      },
      SearchFieldProps: {
        placeholder: l("reactShop.productOverview.filter.placeholders.search"),
        InputProps: {
          classes: {
            root: css.searchField
          },
          startAdornment: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
            color: "primary",
            src: "/img/icons/search.svg",
            size: 24
          })
        },
        TextFieldProps: {
          size: "medium",
          variant: "outlined"
        }
      },
      onChange: onChange,
      onSubmit: onSubmit
    }, /*#__PURE__*/_react.default.createElement(_Select.default, null));
  }), (priceFilter === null || priceFilter === void 0 || (_priceFilter$range = priceFilter.range) === null || _priceFilter$range === void 0 ? void 0 : _priceFilter$range.max) !== (priceFilter === null || priceFilter === void 0 || (_priceFilter$range2 = priceFilter.range) === null || _priceFilter$range2 === void 0 ? void 0 : _priceFilter$range2.min) && /*#__PURE__*/_react.default.createElement(_FilterItem.default, {
    defaultValue: price,
    identifier: "price",
    label: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.productOverview.filter.labels.price",
      l: l
    }),
    lang: lang,
    loading: _loading,
    max: priceFilter === null || priceFilter === void 0 || (_priceFilter$range3 = priceFilter.range) === null || _priceFilter$range3 === void 0 ? void 0 : _priceFilter$range3.max,
    min: priceFilter === null || priceFilter === void 0 || (_priceFilter$range4 = priceFilter.range) === null || _priceFilter$range4 === void 0 ? void 0 : _priceFilter$range4.min,
    showAccordion: isMobile,
    showSelectedValues: true,
    valuePrefix: "\u20AC",
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(_Slider.default, null))));
};
var _default = exports.default = FilterConnector;